import React from "react";
import {
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Grid,
  Card,
  CardContent,
} from "@mui/material";
import ColumnViewPanel from "./card/column-view-panel";
import { ExportButtons } from "./card/export-button";
import SummaryDataTable from "./card/summary-data-table";
import FilterPanel from "./card/filter-panel";

export default function SnSummaryComponent({
  company,
  setCompany,
  fromSequence,
  setFromSequence,
  toSequence,
  setToSequence,
  columnView,
  handleColumnChange,
  handleExport,
  visibleColumns,
  getColumnLabel,
  SN_SUMMARY_COLUMNS,
  companyOptions,
  data,
  isLoading,
  itemPerPage,
  page,
  total,
  onPageClick,
  onItemPerPageChange,
  enableItemPerPageOption,
  isExporting,
  exportingType,
  exportError,
}) {
  return (
    <Box sx={{ p: 3, maxWidth: "100%", bgcolor: "#fff" }}>
      <Typography
        variant="h5"
        component="h1"
        gutterBottom
        sx={{ mb: 1, color: "#1a2a49", fontWeight: 700 }}
      >
        SN Summary
      </Typography>
      <Box sx={{ borderBottom: 1, borderColor: "grey.300", mb: 2 }} />

      <FilterPanel
        company={company}
        setCompany={setCompany}
        fromSequence={fromSequence}
        setFromSequence={setFromSequence}
        toSequence={toSequence}
        setToSequence={setToSequence}
        companyOptions={companyOptions}
      />

      <Box sx={{ display: "flex", gap: 3 }}>
        <ColumnViewPanel
          columns={SN_SUMMARY_COLUMNS}
          columnView={columnView}
          handleColumnChange={handleColumnChange}
        />
        <Card sx={{ flex: 1 }}>
          <CardContent>
            <ExportButtons
              handleExport={handleExport}
              isExporting={isExporting}
              exportingType={exportingType}
              data={data}
              error={exportError}
            />
            <SummaryDataTable
              data={data}
              isLoading={isLoading}
              itemPerPage={itemPerPage}
              page={page}
              total={total}
              onPageClick={onPageClick}
              onItemPerPageChange={onItemPerPageChange}
              columnView={columnView}
              enableItemPerPageOption={enableItemPerPageOption}
              visibleColumns={visibleColumns}
              getColumnLabel={getColumnLabel}
            />
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}
